import React, { useEffect, useState, useContext } from "react";
import OtherIncomeSchedule from "../../../components/Schedules/Others/OtherIncomeSchedule";
import { initSchedule } from "../../../utils/data/initData";
import { AuthContext } from "../../../contexts/AuthContext";
import { useErrorDialog } from "../../../contexts/ErrorDialogContext";
import { useSuccessDialog } from "../../../contexts/SuccessDialogContext";
import ComponentLoading from "../../../components/App/ComponentLoading";
import { handleScheduleDeletion } from "../utils/handleScheduleDeletion";
import { PL_SCHEDULES } from "../../../utils/data/controlData";
import { useAccessControl } from "../../../utils/hooks/useAccessControl";

const OtherIncomeSchedulePage = ({ company, scheduleId }) => {
  const { updatePLSchedule, getScheduleData, deleteScheduleByScheduleType } =
    useContext(AuthContext);
  const [saveTrigger, setSaveTrigger] = useState(false);
  const [schedule, setSchedule] = useState({});
  const [scheduleDetails, setScheduleDetails] = useState({});

  const { canEdit: canEditPLSchedule } = useAccessControl(PL_SCHEDULES);

  const [loading, setLoading] = useState(true);

  const handleError = useErrorDialog();
  const handleSuccess = useSuccessDialog();

  const saveSchedule = async (schedule, scheduleDetails) => {
    if (!company || !scheduleId) {
      handleError("Unexpected error happens. Please try again later.");
      return;
    }

    const updatedSchedule = {
      sch_id: scheduleId,
      scheduleType: "OtherIncome",
      scheduleTitle: schedule.name,
      taxAdjustment: schedule.taxAdjustment,
      otherIncomeRows: scheduleDetails.otherIncomeRows,
      expensesRows: scheduleDetails.expensesRows,
      totalRevenue: scheduleDetails.totalRevenue,
      totalExpenses: scheduleDetails.totalExpenses,
      foreignTaxSuffered: scheduleDetails.foreignTaxSuffered,
      isTagToFTC: scheduleDetails.isTagToFTC,
      notes: schedule.notes,
      reviewNotes: schedule.reviewNotes,
      totalAdjustment: scheduleDetails.totalAdjustment,
      doc: scheduleDetails.doc,
    };
    //console.log("updatedSchedule", updatedSchedule);

    setLoading(true);
    const response = await updatePLSchedule(updatedSchedule);
    setLoading(false);

    if (response) {
      handleSuccess("The schedule has been saved successfully.");
      setSaveTrigger((prev) => !prev);
    } else {
      handleError(
        "There was a problem saving the schedule. Please contact support if the issue persists."
      );
    }
  };

  const deleteSchedule = async () => {
    await handleScheduleDeletion({
      scheduleId,
      deleteFn: deleteScheduleByScheduleType,
      handleSuccess,
      handleError,
      setLoading,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (!company || !scheduleId) {
        handleError(
          "We encountered an issue while fetching the data. Please refresh the page or try again shortly."
        );
        return;
      }
      //API call here
      const response = await getScheduleData(scheduleId, 'Other_Income');

      const scheduleData = response.schedule;
      //init
      if (scheduleData) {
        setSchedule(initSchedule(scheduleData, "Other Income"));
        setScheduleDetails({
          otherIncomeRows: scheduleData.otherIncomeRows,
          expensesRows: scheduleData.expensesRows,
          foreignTaxSuffered: scheduleData.foreignTaxSuffered,
          isTagToFTC: scheduleData.isTagToFTC,
          schRef: scheduleData.schRef || null,
          foreignTaxCreditScheduleRef:
            scheduleData.foreignTaxCreditScheduleRef || null,
        });
      }

      setLoading(false);
    };
    fetchData();
  }, [saveTrigger, scheduleId, getScheduleData, company.uen, updatePLSchedule]);

  return (
    <>
      {loading ? (
        <ComponentLoading />
      ) : (
        <OtherIncomeSchedule
          company={company}
          schedule={schedule}
          scheduleDetails={scheduleDetails}
          saveSchedule={saveSchedule}
          deleteSchedule={deleteSchedule}
          canEditSchedule={canEditPLSchedule}
        />
      )}
    </>
  );
};

export default OtherIncomeSchedulePage;
